import {store} from '../../App';
import config from '../../config';

let axios   = require('axios'),
    io      = require('../io/index').actions,
    i18n    = require('i18next');

export const actiontypes = {}

export const actions = {
  getSpotifyData: (id) => {
    return new Promise((resolve, reject) => {
      let messages = i18n.t('io', {returnObjects: true}).tracks.spotify.getTrackInformation;
      let spotifyToken = localStorage.getItem('spotify_token');
      store.dispatch(io.message(messages.doing, 'information'));

      axios.get(`https://api.spotify.com/v1/tracks/${id}`, {
        headers: {
          'Authorization': `Bearer ${spotifyToken}`
        }
      })
      .then(res => res.data)
      .then(trackdata => {
        axios.get(`https://api.spotify.com/v1/audio-features/${id}`, {
          headers: {
            'Authorization': `Bearer ${spotifyToken}`
          }
        })
        .then(res => res.data)
        .then(metadata => {
          store.dispatch(io.message(messages.success, 'success'));

          resolve({
            artists: trackdata.artists.map(artist => ({name: artist.name})),
            title: trackdata.name,
            releaseDate: trackdata.album.release_date,
            isrc: trackdata.external_ids.isrc,
            explicit: trackdata.explicit,
            metadata
          })
        })
        .catch(err => {
          store.dispatch(io.message(`${messages.error} (${err.message})`, 'error'));
          reject(err)
        })
      })
      .catch(async err => {
        if (!err.response) {
          store.dispatch(io.message(`${messages.error} (${err.message})`, 'error'));
        } else if (err.response.status === 401) {
          spotifyToken = await getSpotifyToken().catch(err => {
            store.dispatch(io.message(`${messages.error} (${err.message})`, 'error'));
            reject(err);
          })
          localStorage.setItem('spotify_token', spotifyToken);
          actions.getSpotifyData(id)
          .then(json => resolve(json))
          .catch(err => {
            store.dispatch(io.message(`${messages.error} (${err.message})`, 'error'));
            reject(err)
          })
        }
        else {
          store.dispatch(io.message(`${messages.error} (${err.message})`, 'error'));
          reject(err);
        }
      });
    })
  },
}


function getSpotifyToken() {
  return new Promise((resolve, reject) => {
    let token = localStorage.getItem('token');
    axios.get(config.API_ADDRESS+'/spotify/auth/token', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(res => res.data)
    .then(json => {
      if (json.message) reject(json.message);
      resolve(json.access_token);
    })
    .catch(err => reject(err));
  })
}



// WEBPACK FOOTER //
// ./src/actions/spotify/index.js